<div id="element-page-filters">
    <form [formGroup]="formGroup">
        <p-dropdown formControlName="selectedCity" [options]="testData" optionLabel="name"></p-dropdown>
    </form>
</div>
